import styled from "styled-components";

export const LoaderContainer = styled.div`
  position: absolute;
  right: 0.5em;
  top: 50%;
  height: 2.5em;
  width: 2.5em;
  transform: translateY(-50%);
`